import { AddProps, convertProps, IFormItemProps, MyModal } from "@/Common/Form/MyModal";
import { DatePicker, Form, Input, Select } from "antd";
import { useEffect, useState } from "react";
import { useCallback } from "react";
import { PurchaseBill } from "@/Models/Tables/PurchaseBill";
import { getPurchaseBillStatusOptions } from "@/Models/Enums/PurchaseBillStatus";
import dayjs, { Dayjs } from "dayjs";

function Item(props: IFormItemProps<PurchaseBill & { deliveryDateValue: Dayjs }>) {
    return <Form.Item {...convertProps(props)}  ></Form.Item>;
}

function Add({ onCancel, onSubmit, data }: AddProps<PurchaseBill>) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const onOk = useCallback(async () => {
        setLoading(true);
        try {
            const t1 = await form.validateFields();
            t1.deliveryDate = t1.deliveryDateValue.valueOf();
            onSubmit({ ...data, ...t1 });
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    }, [data, form, onSubmit]);

    useEffect(() => {
        if (data) {
            form.setFieldValue("deliveryDateValue", dayjs(data.deliveryDate));
        }
    }, [data, form]);

    return <MyModal confirmLoading={loading} name={`采购单`} data={data} width={400} onCancel={onCancel} onOk={onOk}>
        <Form form={form} labelAlign="right" labelCol={{ span: 8 }} initialValues={data}>
            <Item name="deliveryDateValue" label="纳期" labelAlign="right" required >
                <DatePicker />
            </Item>
            <Item name="status" label="状态" labelAlign="right">
                <Select options={getPurchaseBillStatusOptions()} loading={loading} optionFilterProp="label" showSearch allowClear ></Select>
            </Item>
            <Item name="remark" label="备注" >
                <Input.TextArea rows={3} ></Input.TextArea>
            </Item>
        </Form>
    </MyModal>;
}

export default Add;